import { LinearProgress, Stack } from "@mui/material";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { PreviouslyUploadedFiles } from "./PreviouslyUploadedFiles";
import { UploadNewFile } from "./UploadNewFile";
import { usePermissions } from "@poseidon/ui/components";
import { useFiles } from "./useFiles";

export default function FileManagement({
  fileCategory,
  resolveMetadata,
  applicationId,
  agreementId,
  sailorId,
  dealerId,
  readonly,
  showMetadata,
}) {
  const { canWrite } = usePermissions();
  const { loading, error, files } = useFiles({
    fileCategory,
    fileGroup: resolveMetadata.fileGroup,
    agreementId,
    applicationId,
    sailorId,
    dealerId,
  });

  const { setError } = useErrorMessage();

  if (error) {
    setError(error);
  }

  if (loading) {
    return <LinearProgress />;
  }

  return (
    <Stack>
      <PreviouslyUploadedFiles
        files={files}
        resolveMetadata={resolveMetadata}
        readonly={readonly}
        showMetadata={showMetadata}
      />
      {readonly || !canWrite || (
        <UploadNewFile
          fileCategory={fileCategory}
          fileGroup={resolveMetadata.fileGroup}
          filePurposes={
            resolveMetadata.hasFilePurposes &&
            resolveMetadata.getDropdownValues()
          }
          applicationId={applicationId}
          agreementId={agreementId}
          sailorId={sailorId}
          dealerId={dealerId}
          asDealer
        />
      )}
    </Stack>
  );
}
